import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import Login from './pages/Login'
import Tools from './pages/Tools'
import ToolDetail from './pages/ToolDetail'
import ProductDetail from './pages/ProductDetail'
import ServiceDetail from './pages/ServiceDetail'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => { window.scrollTo(0, 0) }, [pathname])
  return null
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Login has its own full-page layout (no shared header/footer) */}
        <Route path="/login" element={<Login />} />

        {/* All other routes share header + footer */}
        <Route
          path="*"
          element={
            <div className="flex min-h-screen flex-col bg-white text-gray-900">
              <Header />
              <div className="flex-1">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/tools" element={<Tools />} />
                  <Route path="/tools/:tool" element={<ToolDetail />} />
                  <Route path="/products/:id" element={<ProductDetail />} />
                  <Route path="/services/:id" element={<ServiceDetail />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </div>
              <Footer />
            </div>
          }
        />
      </Routes>
    </BrowserRouter>
  )
}

function NotFound() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <h1 className="text-6xl font-bold text-gray-900">404</h1>
      <p className="mt-4 text-lg text-gray-500">Page not found</p>
      <a href="/" className="mt-6 text-indigo-600 hover:underline">
        Go home
      </a>
    </div>
  )
}
